import { ApiTaxRate } from '@vend/types/tax'
import React from 'react'
import { useT } from '@transifex/react'
import { Sale } from '../../../models/sale'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'
import { TaxRate } from '../../util/TaxRate'
import { DeleteButton } from '../../shared/DeleteButton'
import { DisplaySaleTax } from './useDisplayTax'
import { TaxRates } from './TaxRates'

type Props = {
  tax: DisplaySaleTax
  removeTax: (rate: ApiTaxRate, taxId: string) => Promise<void | Sale>
  removeAllTax: (taxId: string) => Promise<void | Sale>
  canRemoveTax: boolean
}

/**
 * Component to show a tax group with its rates
 */
export const DisplayTax = (props: Props) => {
  const { tax, removeTax, removeAllTax, canRemoveTax } = props
  const vdCurrencyFilter = useVdCurrencyFilter()
  const t = useT()

  // tax not in a group cause it only has one tax rate
  const singleTax = !tax.isTaxGroup && Object.values(tax.rates).at(0)

  const isRemoveTaxGroup = tax.isTaxGroup && tax.rates.length >= 3
  const isRemoveTax = !!singleTax

  const showRemoveTaxBtn = canRemoveTax && (isRemoveTaxGroup || isRemoveTax)
  const removeTaxEnabled =
    isRemoveTaxGroup || (isRemoveTax && singleTax.removable)

  const onClick = () => {
    if (isRemoveTaxGroup) {
      removeAllTax(tax.id)
    } else if (singleTax) {
      removeTax(singleTax.rate, tax.id)
    }
  }
  return (
    <>
      <tr key={tax.id} className="tax-group">
        <td>
          <strong>{singleTax ? <TaxRate tax={singleTax} /> : tax.name}</strong>
        </td>
        <td className="tax-total">{vdCurrencyFilter(tax.total)}</td>
        <td>
          {showRemoveTaxBtn && (
            <DeleteButton
              disabled={!removeTaxEnabled}
              aria-label={t('Delete tax', { _context: 'Button' })}
              className="vd-btn vd-btn--icon-no"
              onClick={onClick}
              modifier="icon"
              variant="supplementary"
              data-track="remove-tax"
              customDataAttributes={{ root: { 'data-track': 'remove-tax' } }}
            />
          )}
        </td>
      </tr>
      {tax.isTaxGroup && (
        <TaxRates
          removeTax={removeTax}
          taxGroup={tax}
          canRemoveTax={canRemoveTax}
        />
      )}
    </>
  )
}
